export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Th1',
    'Th2',
    'Th3',
    'Th4',
    'Th5',
    'Th6',
    'Th7',
    'Th8',
    'Th9',
    'Th10',
    'Th11',
    'Th12',
  ],
  months: [
    'Th\u00e1ng M\u1ed9t',
    'Th\u00e1ng Hai',
    'Th\u00e1ng Ba',
    'Th\u00e1ng T\u01b0',
    'Th\u00e1ng N\u0103m',
    'Th\u00e1ng S\u00e1u',
    'Th\u00e1ng B\u1ea3y',
    'Th\u00e1ng T\u00e1m',
    'Th\u00e1ng Ch\u00edn',
    'Th\u00e1ng M\u01b0\u1eddi',
    'Th\u00e1ng M\u01b0\u1eddi M\u1ed9t',
    'Th\u00e1ng M\u01b0\u1eddi Hai',
  ],
  months_calendar: {
    January: 'Th\u00e1ng M\u1ed9t',
    February: 'Th\u00e1ng Hai',
    March: 'Th\u00e1ng Ba',
    April: 'Th\u00e1ng T\u01b0',
    May: 'Th\u00e1ng N\u0103m',
    June: 'Th\u00e1ng S\u00e1u',
    July: 'Th\u00e1ng B\u1ea3y',
    August: 'Th\u00e1ng T\u00e1m',
    September: 'Th\u00e1ng Ch\u00edn',
    October: 'Th\u00e1ng M\u01b0\u1eddi',
    November: 'Th\u00e1ng M\u01b0\u1eddi M\u1ed9t',
    December: 'Th\u00e1ng M\u01b0\u1eddi Hai',
  },
  // weekdays
  weekdays: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  weekdays_booking_container: {
    Sunday: 'Ch\u1ee7 Nh\u1eadt',
    Monday: 'Th\u1ee9 Hai',
    Tuesday: 'Th\u1ee9 Ba',
    Wednesday: 'Th\u1ee9 T\u01b0',
    Thursday: 'Th\u1ee9 N\u0103m',
    Friday: 'Th\u1ee9 S\u00e1u',
    Saturday: 'Th\u1ee9 B\u1ea3y',
  },
  weekdays_calendar: {
    Sun: 'CN',
    Mon: 'T2',
    Tue: 'T3',
    Wed: 'T4',
    Thu: 'T5',
    Fri: 'T6',
    Sat: 'T7',
  },
  // additional translations
  today: 'Hôm nay',
  tomorrow: 'Ngày mai',
};
